import React, {  useRef, useState } from "react";
import {
 
  showAPiError_mesage,
} from "../../services/validationService/validationservice";
import {  putData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import messageService from "../../services/message/messageService";
import { useLocation } from "react-router-dom";
import NotesList from "./UIElement/NotesList";
type Customer = {
  selectedCustomer: any;
  setSelectedCustomer: React.Dispatch<any>;
  onCustomerUpdateSuccess: () => Promise<void>;
  activeButton? : number;
  customStyle?:string;
};
export default function CustomerNotes({
  selectedCustomer,
  setSelectedCustomer,
  onCustomerUpdateSuccess,
  activeButton,
  customStyle=""
}: Customer) {
  const [noteText, setNoteText] = useState("");
  const noteRef = useRef(null);
  const { pathname } = useLocation();
  console.log(selectedCustomer)
  const NOTE_API_MAP: Record<string, string> = {
    "/hr": ApiUrl.createEmployeeNote,
    "/dot-compliance": ApiUrl.createDotNote,
    "/candidate/newcandidate" : activeButton === 1 ?  ApiUrl.createEmployeeNote : ApiUrl.createAdminNote,
    "/trail-users":ApiUrl.managedCompanies
  };

  const addNewNote = async () => {
    if (!noteText?.trim() || !selectedCustomer?._id) return;
    const baseUrl = NOTE_API_MAP[pathname];
    // Add more pages in the map accordingly
    if (!baseUrl) {
      messageService().toast("error", "Notes are not supported on this page.");
      return;
    }
    const url = `${baseUrl}${selectedCustomer._id}`;
    try {
      const { error } = await putData(url, { noteText });
      if (error?.message) {
        showAPiError_mesage(error.message);
        return;
      }
      const newNote = {
        date: new Date(),
        noteText,
      };
      setSelectedCustomer((prev: any) => ({
        ...prev,
        notes: prev?.notes ? [...prev.notes, newNote] : [newNote],
      }));
      onCustomerUpdateSuccess()
      setNoteText("");
    } catch (err: any) {
      messageService().toast(
        "error",
        err?.response?.data?.message ?? err.message
      );
    }
  };

  return (
   <div className="flex flex-col h-[calc(86.5vh-200px)] 2xl:h-[calc(88vh-200px)] 4xl:h-[calc(92vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">
             {/* Information table */}
            <div className="grid grid-cols-2 gap-0 h-full ">
              <div className="pr-3 py-0">
                   <div className="flex items-center gap-2 pb-2 pl-1 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[15px]  h- [15px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                      <svg
    className='personIcon'
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.66667H9.85C9.5 0.7 8.58333 0 7.5 0C6.41667 0 5.5 0.7 5.15 1.66667H1.66667C0.75 1.66667 0 2.41667 0 3.33333V15C0 15.9167 0.75 16.6667 1.66667 16.6667H13.3333C14.25 16.6667 15 15.9167 15 15V3.33333C15 2.41667 14.25 1.66667 13.3333 1.66667ZM7.5 1.45833C7.84167 1.45833 8.125 1.74167 8.125 2.08333C8.125 2.425 7.84167 2.70833 7.5 2.70833C7.15833 2.70833 6.875 2.425 6.875 2.08333C6.875 1.74167 7.15833 1.45833 7.5 1.45833ZM5.08333 13.3333H3.33333V11.55L8.3 6.58333L10.0667 8.35L5.08333 13.3333ZM11.5417 6.89167L10.6583 7.775L8.89167 6.00833L9.775 5.125C9.94167 4.95833 10.2 4.95833 10.3667 5.125L11.5417 6.3C11.7083 6.46667 11.7083 6.725 11.5417 6.89167Z"
      fill="#007070"
    />
  </svg>
 
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Notes</h2>
                            </div>

                     <label className="block mb-2 text-xs !mt-3 font-semibold text-gray-700 uppercase">
                        Write Note
                    </label>
              <textarea
                id="message"
                rows={2}
                value={noteText}
                ref={noteRef}
                onChange={(e) => setNoteText(e.target.value)}
                className="w-full p-2 bg-gray-100 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-greenBg focus:border-transparent transition-all h-[130px] min-h-[70px] max-h-[160px]"
                placeholder="Write Note"
              ></textarea>
              <div className="flex justify-end mt-2 ">
                                <div className="
      p-[3.5px]
  rounded-full
  bg-gradient-to-r 
      
      shadow-[0.2px_4px_2px_#D2D2D2]
      hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
  hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
    hover:text-white
   
  ">
  <button
    onClick={addNewNote}
     className="
        px-5 py-1 text-sm
        rounded-full
        bg-white
        text-[#7158E2]
        font-semibold
        transition-all duration-200
        hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
  hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
        hover:text-white
      "
    >
    Save
  </button></div>
</div>
                     {/* READ NOTES */}
                                                            <div className="mt-6">
                                                                <label className="block mb-2 text-xs font-semibold text-gray-700 uppercase">
                                                                    Read Notes
                                                                </label>
                                        
                                                                <NotesList
                                                                    isSideBar={true}
                                                                    notes={selectedCustomer?.notes ?? []}
                                                                    heightClass={'!h-fit'}
                                                                />
                                                            </div>
                                                            </div>

         <div className="border-l-[2px] border-[#D9D9D9] p-3 py-0">

                                <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[16px] h-[16px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                       <svg
    className='personIcon'
    viewBox="0 0 32 32"
    fill="#007070"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 26.016q0 2.496 1.76 4.224t4.256 1.76h20q2.464 0 4.224-1.76t1.76-4.224v-20q0-2.496-1.76-4.256t-4.224-1.76h-20q-2.496 0-4.256 1.76t-1.76 4.256v20zM4 26.016v-20q0-0.832 0.576-1.408t1.44-0.608h20q0.8 0 1.408 0.608t0.576 1.408v20q0 0.832-0.576 1.408t-1.408 0.576h-20q-0.832 0-1.44-0.576t-0.576-1.408zM8 22.016h8v-2.016h-8v2.016zM8 18.016h16v-2.016h-16v2.016zM8 14.016h16v-2.016h-16v2.016zM8 10.016h16v-2.016h-16v2.016z" />
  </svg>
 
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Logs</h2>
                            </div>
                                  {(selectedCustomer?.logs?.length ?? 0) === 0 ?
                        <div className="text-xs text-gray-400 mt-4">
                            No logs available
                        </div> : <NotesList
                            isSideBar={true}
                            notes={selectedCustomer?.logs ?? []}
                            heightClass={'!h-fit'}
                        />
                    }
                            </div>
                        </div>

                        
                    </div>
                    </div>
  );
}
